import ShopData from '@components/LocalMerchant/ShopData'
import ContentData from '@components/LocalMerchant/ContentData'
import { asyncLoad } from '@util'

export default [
  {
    path: 'dataMarketingPage',
    indexRoute: {
      component: asyncLoad(() =>
        import('@components/LocalMerchant/DataMarketingPage')
      )
    },
    stat: '数据中心营销页'
  },
  {
    path: 'shopData',
    component: ShopData,
    stat: '店铺数据/首页'
  },
  {
    path: 'contentData',
    component: ContentData,
    stat: '内容数据/首页'
  },
  {
    path: 'decorationAnalysis',
    component: asyncLoad(() =>
      import('@components/LocalMerchant/DecorationAnalysis')
    ),
    stat: '装修分析/首页'
  }
]
